import AdvancedController from "./advanced-controller";

export class FilterController extends AdvancedController {

  static values = {
    activeFilters: { type: Number, default: 0 },
  }

  connect() {
    super.connect();

    this._addEventListeners();
  }

  resetFilter(e) {
    e.preventDefault();
    FWP.reset();
  }

  _updateActiveFacets() {
    let filters = Object.assign({}, FWP_HTTP.get)
    if (filters.hasOwnProperty('_paged')) {
      delete filters._paged;
    }
    if (filters.hasOwnProperty('_sort')) {
      delete filters._sort;
    }
    if (filters.hasOwnProperty('_s')) {
      delete filters._s;
    }
    this.activeFiltersValue = Object.keys(filters).length
  }

  _addEventListeners() {
    document.addEventListener('facetwp-loaded', () => {

      this._updateActiveFacets();
    });
  }
}